import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from '../config/api';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleChange = (value: string) => {
    i18n.changeLanguage(value);

    // Update the cached user object in localStorage so page refresh restores the correct locale
    const userJson = localStorage.getItem('user');
    if (userJson) {
      try {
        const user = JSON.parse(userJson);
        localStorage.setItem('user', JSON.stringify({ ...user, locale: value }));
      } catch { /* ignore */ }
    }

    // Persist locale to the backend
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${API_BASE_URL}/profile`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ locale: value }),
      }).catch(() => { /* ignore */ });
    }
  };

  return (
    <Select value={i18n.language?.substring(0, 2) || 'en'} onValueChange={handleChange}>
      <SelectTrigger className="w-20 h-8 text-xs bg-white/10 border-white/20 text-primary-foreground hover:bg-white/20 focus:ring-white/30 focus:ring-offset-0">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="en">EN</SelectItem>
        <SelectItem value="fr">FR</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;
